import { Element as HtmlElement, Node } from "html-react-parser";

export const nodeIsTag = (input: Node): input is HtmlElement =>
  input.type === "tag";
